<div class="sticky-footer container-fluid px-5">
   <div class="row my-4">
       <div class="col text-left">
           <ul class="inline-list m-0 p-0">
                <li class="list-inline-item me-4">
                    <a class="text-dark" href="https://www.alachisoft.com/company/contact-us.html" target="_blank">Contact Us</a>
                </li>
                <li class="list-inline-item me-4">
                    <a class="text-dark" href="https://www.alachisoft.com/company/terms-of-use.html" target="_blank">Terms of Use</a>
                </li>
                <li class="list-inline-item">
                    <a class="text-dark" href="https://www.alachisoft.com/company/privacy-policy.html" target="_blank">Privacy Policy</a>
                </li>
           </ul>
       </div>
       <div class="col text-center">
            &copy; Copyright Alachisoft 2002 - 2022. All rights reserved.
       </div>
       <div class="col text-right">
            <ul class="list-inline m-0">
                <li class="list-inline-item me-4">
                    <a href="https://www.facebook.com/NCache/" target="_fb">
                        <i class="fab fa-facebook-f text-dark-grey"></i>
                    </a>
                </li>
                <li class="list-inline-item me-4">
                    <a href="https://twitter.com/NCache/" target="_tw">
                        <i class="fab fa-twitter text-dark-grey"></i>
                    </a>
                </li>
                <li class="list-inline-item me-4">
                    <a href="https://www.youtube.com/c/NCache/" target="_yt">
                        <i class="fab fa-youtube text-dark-grey"></i>
                    </a>
                </li>
                <li class="list-inline-item me-4">
                    <a href="https://www.linkedin.com/company/alachisoft/" target="_li">
                        <i class="fab fa-linkedin-in text-dark-grey"></i>
                    </a>
                </li>
                <li class="list-inline-item">
                    <a href="https://www.alachisoft.com/blogs/feed/?ncache" target="_rss">
                        <i class="fas fa-rss text-dark-grey"></i>
                    </a>
                </li>
            </ul>
       </div>
   </div>
</div>
